import DevViewer from "../components/Viewer/DevViewer";
function DevPage() {
    // return <DemoViewer model_paths={["Demo/Clinic_Ar.min.bmt"]} />;
    return <DevViewer model_paths={["FileSystem/Dev/dev.min.bmt"]} />;
}

export default DevPage;
